import ReportActionTypes from "./report.types";

export const fetchReportsStart = () => ({
  type: ReportActionTypes.FETCH_REPORTS_START,
});

export const fetchReportsSuccess = (reportItems) => ({
  type: ReportActionTypes.FETCH_REPORTS_SUCCESS,
  payload: reportItems,
});

export const fetchReportsFailure = (errorMessage) => ({
  type: ReportActionTypes.FETCH_REPORTS_FAILURE,
  payload: errorMessage,
});

export const setCurrentReport = (report) => ({
  type: ReportActionTypes.SET_CURRENT_REPORT,
  payload: report,
});

export const saveReport = (report, callback) => ({
  type: ReportActionTypes.SAVE_REPORT_START,
  payload: { report, callback },
});
export const saveReportSuccess = (report) => ({
  type: ReportActionTypes.SAVE_REPORT_SUCCESS,
  payload: report,
});
export const saveReportFailure = (error) => ({
  type: ReportActionTypes.SAVE_REPORT_FAILURE,
  payload: error,
});
export const addReport = (report) => ({
  type: ReportActionTypes.ADD_REPORT,
  payload: report,
});
export const setCurrentReportById = (id) => ({
  type: ReportActionTypes.SET_CURRENT_REPORT_BY_ID,
  payload: id,
});
export const rateReport = (report, user, value) => ({
  type: ReportActionTypes.RATE_REPORT_START,
  payload: { report: report, user: user, value: value },
});
export const rateReportSuccess = (rating) => ({
  type: ReportActionTypes.RATE_REPORT_SUCCESS,
  payload: rating,
});
export const rateReportFailure = (errorMessage) => ({
  type: ReportActionTypes.RATE_REPORT_FAILURE,
  payload: errorMessage,
});
export const getUserRating = (reportId, user) => ({
  type: ReportActionTypes.GET_USER_RATING_START,
  payload: { reportId: reportId, user: user },
});
export const getUserRatingSuccess = (rating) => ({
  type: ReportActionTypes.GET_USER_RATING_SUCCESS,
  payload: rating,
});
export const getUserRatingFailure = (errorMessage) => ({
  type: ReportActionTypes.GET_USER_RATING_FAILURE,
  payload: errorMessage,
});
